'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _interface = require('./interface');

var _interface2 = _interopRequireDefault(_interface);

var _events = require('./constants/events');

var _events2 = _interopRequireDefault(_events);

var _auth = require('./mock/auth');

var _features = require('./mock/features');

var _features2 = _interopRequireDefault(_features);

var _jsfOperations = require('jsf-operations');

var _source = require('./mock/source');

var _source2 = _interopRequireDefault(_source);

var _defaultOperations = require('./mock/defaultOperations');

var _defaultOperations2 = _interopRequireDefault(_defaultOperations);

var _scenarios = require('./mock/scenarios');

var _scenarios2 = _interopRequireDefault(_scenarios);

var _deepMerge = require('./helpers/deepMerge');

var _uuid = require('uuid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getAJson = function getAJson(url) {
  return fetch(url);
};

var WebsocketEmulator = function (_Interface) {
  _inherits(WebsocketEmulator, _Interface);

  function WebsocketEmulator() {
    _classCallCheck(this, WebsocketEmulator);

    return _possibleConstructorReturn(this, (WebsocketEmulator.__proto__ || Object.getPrototypeOf(WebsocketEmulator)).apply(this, arguments));
  }

  _createClass(WebsocketEmulator, [{
    key: 'connect',
    value: function connect(config) {
      var _this2 = this;

      // console.log('WebsocketEmulator - OPEN !!!!!!!! 333', config);
      var parentWindow = window.parent;
      parentWindow.postMessage({ type: 'connect' }, '*'); // todo target origin from config
      window.addEventListener("message", function (event) {
        // todo check origin
        var _event$data = event.data,
            type = _event$data.type,
            flatUrl = _event$data.flatUrl,
            fieldsUrl = _event$data.fieldsUrl;

        if (type === 'lazy-connect') {
          _this2.localId = 2;
          _this2.operationBufer = {};
          _this2.emit(_events2.default.CONNECT);
        }

        if (type === 'connect') {
          _this2.flatUrl = flatUrl;
          _this2.fieldsUrl = fieldsUrl;
          if (!_this2.localId) {
            _this2.localId = 2;
            _this2.operationBufer = {};
            _this2.emit(_events2.default.CONNECT);
          }
        }
        if (type === 'document-info') {
          _this2.localId = 2;
          _this2.operationBufer = {};
          _this2.flatUrl = flatUrl;
          _this2.fieldsUrl = fieldsUrl;
          _this2.emit(_events2.default.OPERATIONS, [(0, _source2.default)(_this2.flatUrl)]);
          if (_this2.fieldsUrl) {
            _this2.prepareFields();
          }
        }
      }, false);
    }
  }, {
    key: 'send',
    value: function send(pkg) {
      var _this3 = this;

      if (pkg.auth) {
        setTimeout(function () {
          _this3.emit(_events2.default.AUTH, _auth.auth, _auth.uid);
          _this3.emit(_events2.default.OPERATIONS, _scenarios2.default);
          var op = [].concat(_toConsumableArray(_defaultOperations2.default), [_features2.default]);
          _this3.emit(_events2.default.OPERATIONS, op);
          if (_this3.flatUrl) {
            _this3.emit(_events2.default.OPERATIONS, [(0, _source2.default)(_this3.flatUrl)]);
          }
          if (_this3.fieldsUrl) {
            _this3.prepareFields();
          }
        }, 0);
      } else if (pkg.operations) {
        setTimeout(function () {
          var operations = pkg.operations.map(function (item) {
            if (item.properties.type === "track") {
              return;
            }
            item.confirmed = true;
            item.properties.allowed = true;
            if (!item.id) {
              item.id = { clientId: 1, localId: (0, _uuid.v4)() };
            }
            if (!item.properties.element && item.properties.group === 'tools') {
              item.properties.element = item.id;
            }

            if (item.properties && item.properties.group === 'tools') {
              // console.log('this.operationBufer', this.operationBufer);
              var itemInBuffer = _this3.operationBufer[item.properties.element.localId];
              // console.log('itemInBuffer', itemInBuffer, 'item', item);
              _this3.operationBufer[item.properties.element.localId] = (0, _deepMerge.mergeDeep)({}, itemInBuffer, item); //{
            }
            return item;
          });
          if (operations.length && operations[0]) {
            _this3.emit(_events2.default.OPERATIONS, operations);
          }
        }, 0);
      } else if (pkg.destroy && pkg.params && pkg.params.destroyType === 'done') {
        setTimeout(function () {
          var aJson = _jsfOperations.converter.operationsToDocument(Object.values(_this3.operationBufer));
          window.parent.postMessage({ type: 'done', aJson: aJson, flatUrl: _this3.flatUrl }, '*'); // todo target origin from config
        }, 0);
      }

      // if (pkg.error) {
      //   this.emit(EventsConstants.SERVER_ERROR, pkg.error);
      // }
    }

    /*
    * todo
    **/

  }, {
    key: 'startPing',
    value: function startPing() {
      console.log('startPing');
    }
  }, {
    key: 'prepareFields',
    value: function prepareFields() {
      var _this4 = this;

      getAJson(this.fieldsUrl).then(function (response) {
        return response.json();
      }).then(_jsfOperations.converter.operationsFromDocument).then(function (data) {
        var op = [].concat(_toConsumableArray(data.content.map(function (item) {
          item.properties.initial = true;
          item.properties.enabled = true;
          item.id = { clientId: 1, localId: (0, _uuid.v4)() };
          item.properties.element = item.id;
          if (item.properties && item.properties.group === 'tools') {
            if (item.properties.content) item.properties.content.owner = '';
            _this4.operationBufer[item.properties.element.localId] = item;
          }
          return item;
        })), [{
          "properties": { "group": "editor", "type": "mode", "allowed": true, "subType": "main" }
        }]);
        _this4.emit(_events2.default.OPERATIONS, op);
      });
    }
  }]);

  return WebsocketEmulator;
}(_interface2.default);

var wse = new WebsocketEmulator();
exports.default = wse;